import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f300982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xs-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Updated By:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-edit" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-delete" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_22 = {
  key: 3,
  class: "col-md-3 p-0"
}
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label small",
  for: "permanent"
}, " Make Permanent ", -1))
const _hoisted_25 = { class: "col-md-3 p-0" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label small",
  for: "advisory"
}, " Make Advisory ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_GenericModalVue = _resolveComponent("GenericModalVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    _createVNode(_component_GenericModalVue, {
      show: _ctx.showModal,
      "body-text": 'Are you sure you want to delete the note?',
      "header-text": 'WARNING!!!',
      "is-question": true,
      "is-warning": true,
      onClose: _ctx.onCloseModal
    }, null, 8, ["show", "onClose"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note) => {
          return (_openBlock(), _createElementBlock("div", {
            key: note.Id,
            class: _normalizeClass(note.CssClass || 'notes')
          }, [
            _createElementVNode("p", null, [
              _createElementVNode("em", null, _toDisplayString(note.CreatedByName), 1),
              _hoisted_3,
              _createElementVNode("em", null, _toDisplayString(note.DateCreated), 1),
              (note.DateUpdated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("em", null, _toDisplayString(note.UpdatedByName), 1),
                    _hoisted_7,
                    _createElementVNode("em", null, _toDisplayString(note.DateUpdated), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(note.Text), 1)
            ]),
            (note.Type !== _ctx.OrderNoteType.System)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "edit-icon",
                  onClick: ($event: any) => (_ctx.updateNote(note.Id))
                }, _hoisted_10, 8, _hoisted_8))
              : _createCommentVNode("", true),
            (note.Type !== _ctx.OrderNoteType.System)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "delete-icon",
                  onClick: ($event: any) => (_ctx.deleteNote(note.Id))
                }, _hoisted_13, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noteMessage) = $event)),
          rows: "4",
          cols: "20"
        }, null, 512), [
          [_vModelText, _ctx.noteMessage]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.noteMessage,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewNote()))
            }, " Add New Note ", 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.noteMessage,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveNote()))
            }, " Update ", 8, _hoisted_20)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel()))
            }, " Cancel ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.type === _ctx.OrderNoteType.Order)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                id: "permanent",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.permanent) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.advisory = false))
              }, null, 544), [
                [_vModelCheckbox, _ctx.permanent]
              ]),
              _hoisted_24
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "advisory",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.advisory) = $event)),
            disabled: !_ctx.permanent && _ctx.type === _ctx.OrderNoteType.Order
          }, null, 8, _hoisted_27), [
            [_vModelCheckbox, _ctx.advisory]
          ]),
          _hoisted_28
        ])
      ])
    ])
  ], 64))
}